var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.5 491.5",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.9 462.7c-.6 0-1.1-.1-1.6-.3l-104.5-38.6-104.5 38.6c-1.1.4-2.2.4-3.3 0l-106.1-39.2c-1.9-.7-3.1-2.5-3.1-4.4v-305c0-1.5.8-3 2-3.9 1.3-.9 2.9-1.1 4.4-.6l104.5 38.7 104.5-38.6c1.1-.4 2.2-.4 3.3 0l29.3 10.8c2.4.9 3.7 3.6 2.8 6.1-.9 2.4-3.6 3.7-6.1 2.8l-27.7-10.2-104.5 38.6c-1.1.4-2.2.4-3.3 0l-99.7-36.8v294.9l101.4 37.4 104.5-38.6c1.1-.4 2.2-.4 3.3 0l104.5 38.6 101.4-37.4v-295l-22.9 8.5c-2.4.9-5.2-.4-6.1-2.8-.9-2.5.3-5.2 2.8-6.1l29.3-10.8c1.5-.5 3.1-.3 4.4.6s2 2.3 2 3.9v305c0 2-1.2 3.8-3.1 4.4l-106.1 39.2c-.7.1-1.3.2-1.8.2z",
    fill: "#c72538"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.7 462.7c-2.6 0-4.7-2.1-4.7-4.7v-305c0-2.6 2.1-4.7 4.7-4.7s4.7 2.1 4.7 4.7v305c0 2.6-2.1 4.7-4.7 4.7z",
    fill: "#c72538"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.8 423.5c-2.6 0-4.7-2.1-4.7-4.7v-305c0-2.6 2.1-4.7 4.7-4.7s4.7 2.1 4.7 4.7v305c0 2.6-2.1 4.7-4.7 4.7z",
    fill: "#c72538"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M351.9 462.7c-2.6 0-4.7-2.1-4.7-4.7v-186.9c0-2.6 2.1-4.7 4.7-4.7s4.7 2.1 4.7 4.7v186.9c0 2.6-2.1 4.7-4.7 4.7z",
    fill: "#c72538"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M458 376.8c-.7 0-1.4-.2-2.1-.5l-104.4-51.1-104.3 32.2c-1.9.6-4-.1-5.2-1.7l-102.7-141.7-102.2 119.7c-1.7 2-4.7 2.2-6.7.5s-2.2-4.7-.5-6.7l106.1-124.3c.9-1.1 2.3-1.7 3.8-1.7 1.5.1 2.8.8 3.7 2l104.1 143.9 102.9-31.8c1.2-.4 2.4-.3 3.5.3l106.1 52c2.3 1.1 3.3 4 2.2 6.3-.9 1.7-2.6 2.6-4.3 2.6z",
    fill: "#c72538"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M351.9 38.3c-40.6 0-73.6 33-73.6 73.6 0 27.7 30.9 78.1 53.4 114.8 8 13 15.1 24.6 20.2 34.1 5.2-9.5 12.3-21.1 20.2-34.1 22.5-36.7 53.4-87.1 53.4-114.8 0-40.6-33-73.6-73.6-73.6zm0 237.6c-1.8 0-3.5-1.1-4.3-2.7-4.8-10.1-13.7-24.6-24-41.5-24.4-39.8-54.8-89.3-54.8-119.8 0-45.8 37.3-83.1 83.1-83.1s83.1 37.3 83.1 83.1c0 30.4-30.4 80-54.8 119.8-10.3 16.9-19.3 31.4-24 41.5-.8 1.6-2.5 2.7-4.3 2.7z",
    fill: "#c72538"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M351.9 79.7c-19 0-34.4 15.4-34.4 34.4s15.4 34.4 34.4 34.4 34.4-15.4 34.4-34.4-15.5-34.4-34.4-34.4zm0 78.2c-24.2 0-43.9-19.7-43.9-43.9s19.7-43.9 43.9-43.9 43.9 19.7 43.9 43.9c-.1 24.3-19.7 43.9-43.9 43.9z",
    fill: "#c72538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.918d0e8ae9152eaf34e314eb292b2bba.svg";
export { ForwardRef as ReactComponent };